import type { Locale } from '@seek/melways-sites';
import { observer } from 'mobx-react';
import type React from 'react';

import type { IProspect } from '../../../../stores/JobApplicationStore/CandidateStore';
import type { IEmail } from '../../../../stores/JobApplicationStore/Email';
import type { INote } from '../../../../stores/JobApplicationStore/Note';
import { STATE_LOADING } from '../../../../stores/state';
import Loader from '../../../common/Loader';

import EmailItem from './EmailItem';
import NoteItem from './NoteItem';
import getTimeline from './getTimeline';

interface Props {
  previousApplication: IProspect;
  locale: Locale;
}

const Timeline: React.FC<Props> = ({ previousApplication, locale }) => {
  const { prospectEmailStore, notes } = previousApplication;

  if (
    prospectEmailStore.state === STATE_LOADING ||
    notes.state === STATE_LOADING
  ) {
    return <Loader />;
  }

  const timeline = getTimeline(previousApplication);

  return (
    <>
      {timeline.map((item) => {
        if (item.type === 'email') {
          const email = item.object as IEmail;
          return <EmailItem email={email} key={email.id} locale={locale} />;
        } else if (item.type === 'note') {
          const note = item.object as INote;
          return <NoteItem note={note} key={note.id} locale={locale} />;
        }
      })}
    </>
  );
};

export default observer(Timeline);
